import type { QueryClient } from '@tanstack/react-query';

/**
 * Po każdej zmianie tego, CO liczy się do marki — status nazwy albo marki, połączenie i rozdzielenie marek —
 * nieaktualne są WSZYSTKIE statystyki projektu: każdy odczyt filtruje nazwy wyłączone i grupuje marki przy
 * odczycie (ranking, SoV, widoczność, widoczność per prompt, wykresy, Insights, widok promptu, słownik marek).
 * Wcześniej każde miejsce unieważniało własną, niepełną listę kluczy, więc np. widoczność per prompt
 * pokazywała stare liczby przez `staleTime` (5 min), dopóki ktoś nie odświeżył strony.
 *
 * Dlatego całość, bez wyliczania kluczy: aktywne zapytania odświeżają się od razu, pozostałe przy następnym
 * wejściu na stronę. Zmiana etykiety marki to tylko wyświetlanie — ona tego nie potrzebuje.
 */
export const invalidateBrandStats = (queryClient: QueryClient): Promise<void> => queryClient.invalidateQueries();
